import ApplicationController from './application_controller';

export default class Typography extends ApplicationController {

  static targets = ['hiddenFieldHeader', 'hiddenFieldBody']

  connect() {
    //set initial highlighted state for dialogs
    const hiddenHeaderValue = document.getElementById('header-font-value').value
    const hiddenBodyValue =  document.getElementById('body-font-value').value

    this.initialSelectedFont('#header-dialog', hiddenHeaderValue)
    this.initialSelectedFont('#body-dialog', hiddenBodyValue)
    this.initialSelectedPresetFonts(hiddenHeaderValue, hiddenBodyValue)
  }

  setHeaderValue() {
    //set values in hidden input
    const fontName = document.querySelector('#header-dialog li.preset-selected').textContent.trim();
    this.handleHeaderValue(fontName)
  }

  setBodyValue() {
    const fontName = document.querySelector('#body-dialog li.preset-selected').textContent.trim();
    this.handleBodyValue(fontName);
  }

  setPresetValues() {
    const parentUlItem = document.querySelector('#preset-dialog ul.preset-selected');
    const headerValue = parentUlItem.querySelector('.preset-font-pairing--header').textContent.trim();
    const bodyValue = parentUlItem.querySelector('.preset-font-pairing--body').textContent.trim();

    this.handleHeaderValue(headerValue) 
    this.handleBodyValue(bodyValue) 
  }

  selectHeaderFont() {
    //highlight selected font
    event.preventDefault();
    const parentLiItem = event.target.closest('li')

    if (parentLiItem) {
      const allLiItems = document.querySelectorAll('li.font-row-header');

      this.handleFontSelectHighlight(allLiItems, parentLiItem)
    }
  }

  selectBodyFont(){
    event.preventDefault();
    const parentLiItem = event.target.closest('li')

    if (parentLiItem) {
      const allLiItems = document.querySelectorAll('li.font-row-body');

      this.handleFontSelectHighlight(allLiItems, parentLiItem)
    }
  }

  selectPresetFonts() {
    event.preventDefault(); //stop dialog from jumping around on clicks
    const parentUlItem = event.target.closest('ul')
    const allUlItems = document.querySelectorAll('ul.preset-font-pairing');

    this.handleFontSelectHighlight(allUlItems, parentUlItem)
  }

  handleFontSelectHighlight(items, parent) {
    items.forEach(item => { 
      item.style.backgroundColor = '';
      item.classList.remove('preset-selected')
      item.querySelector('.font-selector-checkmark ').style.display = 'none'
    })

    parent.classList.add('preset-selected');
    parent.querySelector('.font-selector-checkmark ').style.display = 'block'
  }

  handleBodyValue(fontName) {
    const bodyFontExample = document.getElementById("body_font_example");
    const bodyFontName = document.getElementById("body_font_name");

    this.hiddenFieldBodyTarget.value = fontName
    bodyFontExample.style.fontFamily = fontName
    bodyFontName.textContent = fontName
  }

  handleHeaderValue(fontName) {
    const headerFontExample = document.getElementById("header_font_example");
    const headerFontName = document.getElementById("header_font_name");

    this.hiddenFieldHeaderTarget.value = fontName
    headerFontExample.style.fontFamily = fontName
    headerFontName.textContent = fontName
  }

  initialSelectedFont(elementID, elementValue) {
    const matchingLi = Array.from(document.querySelectorAll(`${elementID} li`))
    .find(li => li.textContent.trim() === elementValue);

    matchingLi.classList.add('preset-selected');
    matchingLi.querySelector('.font-selector-checkmark').style.display = 'block'
  }

  initialSelectedPresetFonts(headerValue, bodyValue) {
    const targetUl = Array.from(document.querySelectorAll('#preset-dialog ul')).find(ul => {
      const items = ul.querySelectorAll('li');
      return items[0].textContent.trim() === headerValue && items[1].textContent.trim() === bodyValue;
    });

    if (targetUl) {
      targetUl.classList.add('preset-selected');
      targetUl.querySelector('.font-selector-checkmark').style.display = 'block'
    }
  }
}
